import posthog from "posthog-js";

export type ExperimentVariant = "control" | "hidden";

/**
 * Get the CRO-WEB-168 experiment variant from PostHog feature flag
 * Returns "control" to show subscription cards, "hidden" to hide them
 */
export const getCroWeb168VariantFromFeatureFlag =
  (): ExperimentVariant | null => {
    if (typeof window === "undefined") return "hidden";

    try {
      const flagValue = posthog.isFeatureEnabled("cro-web-168");
      // PostHog feature flag returns true/false, map to our variants
      const variant = flagValue ? "hidden" : "control";
      return variant;
    } catch (error) {
      // Return hidden as fallback for testing
      return "hidden";
    }
  };
